<p-toast></p-toast>
<!--
  A second toast container, for the one action that reports on itself while it runs rather than
  landing all at once. Re-registering a user hands the work to a queue and then polls, so its
  message has to be replaced in place as the attempt moves along -- and `MessageService.clear()`
  without a key would take every unrelated toast down with it. Bottom-left keeps a sticky
  progress message clear of the top-right stack, where an interceptor error would otherwise be
  pushed down by it or hidden behind it.
-->
<p-toast key="registration-progress" position="bottom-left"></p-toast>
<router-outlet></router-outlet>
<p-confirm-dialog/>
